// extracted by mini-css-extract-plugin
export var contact = "ContactUs-module--contact--35G4q";
export var person = "ContactUs-module--person--xH-eh";
export var list = "ContactUs-module--list--3gUxZ";
export var rightCol = "ContactUs-module--rightCol--3FeHJ";
export var formWrapper = "ContactUs-module--formWrapper--2Qlq4";
export var title = "ContactUs-module--title--2TS_C";
export var formButtons = "ContactUs-module--formButtons--2xGcg";
export var messageSentText = "ContactUs-module--messageSentText--3fWHk";